<template>
  <div class="people-management-container">
    <div class="people-management-body">
      <div class="content">
        <div class="left">
          <div class="title">
            <h3>组织机构</h3>
          </div>
          <div class="custom-tree tree">
            <el-tree
              ref="tree"
              :data="nodeList"
              :props="defaultProps"
              node-key="id"
              :expand-on-click-node="false"
              :default-expanded-keys="defaultOpenMenu"
              @node-click="nodeClick"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="right">
          <account-list
          ref='accountList'
          :deptId="selectDeptId"
          :addButton="[{'name': '添加', 'callback': () => editPeopleInfo()}, {'name': '导入', 'callback': () => importPeoples()}]"
          :editButotn="[{'name':'编辑', 'callback': (data)=> editPeopleInfo(data)},{'name':'查看权限', 'callback': (data)=> getRolePower(data)},{'name':'重置密码', 'callback': (data)=> resetPassword(data)}]"
          :useInvalidAccount="true"></account-list>
        </div>
      </div>
    </div>
    <el-dialog
      class="power-list-dialog"
      :title="rolePowerDialog.title"
      :visible.sync="rolePowerDialog.dialogVisible"
      width="450px"
      center
      :before-close="handleClose">
      <power-list-tree ref="powerListTree" :checkedList="checkedList" :powersListObj="powersListObj" :loadingPowerLists="loadingPowerLists" :disabled="true">
        <div class="home-page" slot="homePage" v-loading="loadingPowerLists && $refs.powerListTree && $refs.powerListTree.currentClickMenu === 'other'"
             element-loading-text="加载中..."
             element-loading-spinner="el-icon-loading">
          <el-checkbox v-model="homePagePower" @change="(val) => setHomePagePower(val, 'checked')" disabled>首页</el-checkbox>
          <label class="home-page-label">群组主页</label>
          <el-select v-model="home" clearable placeholder="请选择" filterable @change="setHomePagePower" disabled>
            <el-option
              v-for="(item, index) in menuList"
              :key="item.id + index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </power-list-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rolePowerDialog.dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
     <div class="dialog-form" v-if="peopleDetailsDialog.dialogVisible">
      <div>
        <div class="diglog-form-title">
          人员详情
          <span class="close" @click="peopleDetailsDialog.dialogVisible=false">X</span>
          <div class="line"></div>
        </div>
        <people-details class="people-detail-box" :depId="peopleDetailsDialog.depId" :userId="peopleDetailsDialog.userId" @closeDialog="closeDialog"></people-details>
      </div>
    </div>
    <div class="modal" v-show="peopleDetailsDialog.dialogVisible"></div>
    <!-- 导入 TODO: 如果后续还有使用该弹框的，随手封装下。 -->
    <el-dialog
      v-if="importParams.visible"
      title="导入"
      :visible.sync="importParams.visible"
      center
      append-to-body
      :close-on-click-modal="false"
      width="530px"
      class="people-management-dialog">
      <div class="runtime-dialog-file">
        <div class="runtime-dialog-file-title">请先下载模板，然后按格式导入<el-button :disabled="importParams.downloading" @click.stop="downDataTemplate()" type="primary">下载模板</el-button></div>
        <div class="runtime-dialog-file-upload">
          <!--handleClearFiles事件不生效,记得处理 -->
          <el-upload
            action=""
            ref="uploadButton"
            class="el-upload"
            :http-request="upDataTemplate"
            accept=".xls,.xlsx"
            :limit="1"
            :before-upload="beforeUpload"
            :on-success="afterUpload"
            :on-error="afterUpload"
            :show-file-list="false">
            <el-button type="primary" @click="handleClearFiles">上传文件</el-button>
          </el-upload>
          <el-tooltip effect="dark" content="仅支持xls,xlsx" placement="right">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <!-- 文件图标框-->
        <div :class="['runtime-dialog-file-rectangle',(importParams.fileStatus === 'uploadFail' || importParams.fileStatus === 'importFail' || importParams.fileStatus === 'afterImport')&& 'runtime-dialog-file-rectangle-fail', (importParams.fileStatus === 'uploadSuccess' || importParams.fileStatus === 'importSuccess' || importParams.fileStatus === 'isImporting') && 'runtime-dialog-file-rectangle-success']"></div>
        <el-progress :percentage="importParams.fileProgress" :style="{visibility:importParams.fileProgress !==0 ? 'visible':'hidden'}" :stroke-width="4" :show-text="false"></el-progress>
        <!-- 文件名，导入失败结果展示-->
        <p class="fileStatusName" :style="{visibility: importParams.fileStatus && (importParams.fileStatus !== 'isUploading' || importParams.fileStatus === 'afterImport')?'visible':'hidden'}">
          <span v-if="importParams.fileStatus !== 'importFail'">{{importParams.fileName}}&emsp;<i class="el-icon-success" v-show="importParams.fileStatus === 'uploadSuccess' || importParams.fileStatus === 'importSuccess'"></i></span>
        </p>
        <div class="runtime-dialog-file-name">文件将被导入至: 系统人员管理</div>
        <!-- 上传结果，导入结果展示-->
        <p :class="['runtime-dialog-file-status',{'file-status-visible':importParams.fileStatus && importParams.fileStatus !== 'isUploading' && importParams.fileStatus !== 'isImporting','file-status-color':importParams.fileStatus === 'uploadFail' || importParams.fileStatus === 'importFail' || importParams.fileStatus === 'afterImport'}]">
          <span v-if="!importParams.fileStatus.includes('Import') && !importParams.fileStatus.includes('import')">{{importParams.fileStatus === 'uploadSuccess'?'上传成功!':'上传失败'}}</span>
          <span v-else-if="importParams.fileStatus === 'afterImport'">
            <span class="error-file-down" @click="downErrorTemplate">{{ importParams.errorFile.file }}</span>
            &nbsp;&nbsp;导入失败
          </span>
          <span v-else-if="importParams.fileStatus === 'importSuccess'">导入成功!</span>
        </p>
        <el-button v-if="importParams.uploadResult.showButton" type="primary" @click="importDataTemplate" :loading="importParams.fileStatus === 'isImporting'">立即导入</el-button>
        <el-button class="cancal-button" @click="closeImportDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AccountList from './account-list.vue'
import PeopleDetails from './people-details.vue'
import PowerListTree from '@/components/system/power-list-tree.vue'
import { rolePowerMixin } from './usersMixin'

export default {
  name: 'peopleManagement',
  components: {
    AccountList,
    PeopleDetails,
    PowerListTree
  },
  mixins: [rolePowerMixin],
  data () {
    return {
      defaultOpenMenu: [],
      nodeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      name: '',
      selectDeptId: '',
      // 选中第一个的时候，获取全部列表
      firstId: '',
      peopleDetailsDialog: {
        dialogVisible: false,
        userId: '',
        depId: ''
      },
      selectPowerId: '',
      rolePowerDialog: {
        dialogVisible: false,
        title: ''
      },
      // 导入
      importParams: {
        visible: false,
        fileName: '',
        fileStatus: '',
        fileProgress: 0,
        errorDataUrl: '',
        fileDir: '',
        uploadResult: {
          successDataCount: 0,
          errorDataCount: 0,
          dataCount: 0,
          modificationTime: '',
          showButton: true
        },
        // 是否正在下载
        downloading: false,
        // 导入失败
        errorFile: {
          // 文件名
          file: '',
          // 路径
          dir: ''
        }
      }
    }
  },
  methods: {
    // 重置密码
    resetPassword (row) {
      let params = {
        id: row.id
      }
      this.$axios.post(`/auth-api/users/resetPassword`, params).then(res => {
        if (res.data) {
          this.$alert('密码已重置为 888888', '重置密码', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    editPeopleInfo (row) {
      this.peopleDetailsDialog.depId = row ? row.departmentId : this.selectDeptId
      this.peopleDetailsDialog.userId = row ? row.id : undefined
      this.peopleDetailsDialog.dialogVisible = true
    },
    // 获取角色权限
    getRolePower (row) {
      this.selectPowerId = row.id
      this.getAllMenusAndPowers()
      this.rolePowerDialog.title = row.name + '当前权限'
      this.rolePowerDialog.dialogVisible = true
    },
    closeDialog (type) {
      this.peopleDetailsDialog.dialogVisible = false
      if (type === 'save') {
        this.$refs.accountList.getAccountList()
      }
    },
    getOrganizationTree () {
      this.$axios.get('/auth-api/organization/getTree').then(res => {
        this.nodeList = res.data || []
        this.$nextTick(() => {
          this.firstId = this.nodeList[0].id
          this.defaultOpenMenu.push(this.nodeList[0].id)
          if (!this.selectDeptId) {
            this.selectDeptId = this.nodeList[0].id
          }
          this.$nextTick(() => {
            this.$refs.tree && this.$refs.tree.setCurrentKey(this.selectDeptId)
          })
        })
      })
    },
    nodeClick (node) {
      this.selectDeptId = node.id
    },
    // 导入
    importPeoples () {
      this.importParams.visible = true
    },
    // 下载模板
    async downDataTemplate () {
      if (this.importParams.downloading) return false
      this.importParams.downloading = true
      try {
        await this.$axios.get('/auth-api/users/template').then(res => {
          if (res.data && res.data[0] && res.data[0].status === 'success') {
            let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
            window.open(`${ossDownloadUrl}${res.data[0].result.dir}`)
          }
        })
        // 直接使用promise自带的 finally 低版本可能不兼容。
      } finally {
        this.importParams.downloading = false
      }
    },
    // 上传文件
    async upDataTemplate (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      fd.append('type', 'USER')
      try {
        await this.$axios.post(`/shared-api/files/uploadFiles`, fd, {
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.importParams.fileProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100)
            }
          }
        }).then((res) => {
          if (res.data && res.data[0].status === 'success') {
            this.importParams.fileStatus = 'uploadSuccess'
            this.importParams.fileName = res.data[0].result.file
            this.importParams.fileDir = res.data[0].result.dir
          } else {
            this.importParams.fileStatus = 'uploadFail'
          }
        }).catch(() => {
          this.importParams.fileStatus = 'uploadFail'
        })
        // 直接使用promise自带的 finally 低版本可能不兼容。
      } finally {
        // 不管上传失败还是成功，需要把进度条清零
        this.importParams.fileProgress = 0
      }
    },
    beforeUpload () {
      // 如果上传失败了，重新选择文件后需要重新显示 导入按钮
      if (!this.importParams.uploadResult.showButton) {
        this.importParams.uploadResult.showButton = true
      }
      this.importParams.fileStatus = 'isUploading'
    },
    afterUpload () {
      this.importParams.fileProgress = 0
    },
    handleClearFiles () {
      if (this.$refs.uploadButton instanceof Array) {
        this.$refs.uploadButton[0].clearFiles()
      } else {
        this.$refs.uploadButton.clearFiles()
      }
    },
    // 导入
    async importDataTemplate () {
      if (!this.importParams.fileDir) return this.$message.error('请先上传文件！')
      this.importParams.fileStatus = 'isImporting'
      let fd = new FormData()
      fd.append('excelFileUrl', this.importParams.fileDir)
      await this.$axios.post('/auth-api/users/importUserData', fd).then(res => {
        // 如果有返回数据就都是错误数据
        if (res && res.data) {
          this.importParams.fileStatus = 'afterImport'
          this.importParams.errorFile.file = res.data.result.file
          this.importParams.errorFile.dir = res.data.result.dir
        } else {
          this.importParams.fileStatus = 'importSuccess'
          this.$message.success('导入成功！')
          this.closeImportDialog()
        }
        this.importParams.uploadResult.showButton = false
      }).catch(() => {
        // 文件数据不对不会报错,非本报表的表格导入等其他问题才会报错,导入状态不置为失败
        this.importParams.fileStatus = 'afterImport'
        this.importParams.uploadResult.showButton = false
      })
    },
    closeImportDialog () {
      if (this.importParams.visible) {
        this.importParams.visible = false
      }
      if (this.importParams.errorDataUrl) {
        this.importParams.errorDataUrl = ''
      }
      if (this.$refs.uploadButton instanceof Array) {
        this.$refs.uploadButton[0].clearFiles()
      } else {
        this.$refs.uploadButton.clearFiles()
      }
      this.importParams.fileStatus = ''
      this.importParams.fileProgress = 0
      this.importParams.fileDir = ''
      this.importParams.uploadResult.showButton = true
    },
    handleClose (done) {
      this.resetRoleList()
      done()
    },
    downErrorTemplate () {
      if (this.importParams.errorFile && this.importParams.errorFile.dir) {
        let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
        window.open(`${ossDownloadUrl}${this.importParams.errorFile.dir}`)
      }
    }
  },
  mounted () {
    this.getOrganizationTree()
    // 获取角色权限类型设置为 人员管理
    this.rolePowerType = 'peopleManagement'
  },
  watch: {
    'importParams.visible' (val) {
      if (!val) {
        this.closeImportDialog()
      }
    }
  }
}
</script>

<style lang="scss">
  [v-cloak] {
    display: none;
  }

  .people-management-container {
    height: 100%;
    position: relative;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .people-management-body {
      height: 100%;
      padding: 10px;
      >.content {
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        -webkit-justify-content: space-between;

        .left {
          background: #fff;
          box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
          border-radius: 4px 0;
          height: 100%;
          padding-top: 13px;
          flex: 2;
          overflow: scroll;

          .title {
            h3 {
              border-left: 2px solid var(--primary, #62a8f2);
              padding-left: 12px;
              font-size: 14px;
              font-weight: 500;
            }
          }

          .tree {
            display: inline-block;
            min-width: 100%;
            padding: 10px 0 0 20px;

            .el-tree{
              .custom-tree-node{
                span:first-of-type{
                  display: inline-block;
                  width: 120px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .right {
          background: #fff;
          box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
          border-radius: 4px 0;
          height: 100%;
          flex: 9;
          margin-left: 15px;
          overflow: auto;
          padding: 10px;
        }
        @media screen and (max-width: 1400px) {
          .right {
            flex: 6;
          }

          .left {
            flex: 2;
          }
        }
      }
    }
    .power-list-dialog{
      .el-dialog__title{
        font-size: 14px;
      }
      .el-dialog__body{
        .home-page{
          margin-top: 10px;
          margin-bottom: 10px;
          padding-left: 25px;
          .el-checkbox{
            display: block;
            margin-bottom: 10px;
            margin-left: -25px;
            padding-left: 10px;
            .el-checkbox__label{
              color: #606266;
              cursor: not-allowed;
            }
            .el-checkbox__inner {
              border: 1px solid #ABABAB;
              background-color: #ffffff;
              &::after{
                border: 1px solid #ABABAB;
                border-left: 0;
                border-top: 0;
              }
            }
          }
          .home-page-label{
            display: block;
            padding-left: 10px;
            margin: 0 10px 10px 0;
            color: #606266;
          }
        }
      }
    }
    .el-dialog__body {
      height: 600px;
    }
  }

.modal {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .5;
  background: #000;
  z-index: 200;
}

.dialog-form {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 201;
  border: 1px solid #E6E6E6;
  border-top: none;
  .people-detail-box {
    height: 100%;
    background: #fff;
  }

  >div {
    width: 100%;
    height: calc(100% - 34px);
    .diglog-form-title{
      position: relative;
      text-align: center;
      height: 34px;
      line-height: 34px;
      background: #fff;
      top:0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      .line {
        width: 98%;
        height: 1px;
        background: #EDEEEE;
        position: absolute;
        bottom: 1px;
        left: 0.86%;
      }

      .close {
        position: absolute;
        right: 20px;
        top: 0;
        cursor: pointer;
        z-index: 201;
        color: #ADAFB0;
        &:hover {
          color: red;
        }
      }
    }
  }
}
@import "@/assets/scss/common.scss";
.people-management-dialog {
  .el-dialog {
    border-radius: 4px;
  }
  .el-dialog__header {
    height: 34px;
    line-height: 34px;
    padding: 0;
  }
  .el-dialog__body {
    padding: 25px 16px 30px;
    .runtime-dialog-file{
      text-align: center;
      .runtime-dialog-file-title{
        margin-bottom: 30px;
        .el-button{
          position: relative;
          left: 48px;
          padding: 5px 10px;
        }
      }
      .runtime-dialog-file-upload{
        .el-icon-info{
          color: #C1C1C1;
          cursor: pointer;
          position: absolute;
          left: 318px;
          padding-top: 5px;
          &:hover{
            color: #409EFF;
          }
        }
      }
      .el-button{
        padding: 5px 10px;
        span{
          font-size: 12px;
        }
        &.cancal-button{
          width: 76px;
        }
      }
      p:not(.fileStatusName){
        height: 20px;
        line-height: 20px;
      }
      p {
        .el-icon-success{
          color:#67C23A;
        }
        span .el-icon-download{
          margin-left: 18px;
          cursor: pointer;
          color:#54ABF1;
          &:active{
            color:#3F91D3;
          }
        }
        &.fileStatusName {
          span {
            margin-bottom: 25px;
            display: block;
          }
        }
      }
      .runtime-dialog-file-name{
        span{
          padding-left: 17px;
        }
      }
      .runtime-dialog-file-status{
        visibility: hidden;
        margin: 25px 0;
        color:#54ABF1;
        .error-file-down {
          color: #000;
          cursor: pointer;
          &:hover {
            color: #54ABF1;
          }
        }
      }
      .runtime-dialog-file-status.file-status-visible{
        visibility: visible;
      }
      .runtime-dialog-file-status.file-status-color{
        color:#F9355A;
      }
      .runtime-dialog-file-rectangle{
        width:76px;
        height:70px;
        background:#EAF5FD;
        margin: 15px auto;
      }
      .runtime-dialog-file-rectangle.runtime-dialog-file-rectangle-fail{
        background:#EFF0F1 url('../../report/runtime/assets/upload-fail.png') no-repeat center/cover;
      }
      .runtime-dialog-file-rectangle.runtime-dialog-file-rectangle-success{
        background:#EFF0F1 url('../../report/runtime/assets/excel.png') no-repeat center/60%;
      }
      .el-progress{
        width: 76px;
        margin: 0 auto;
      }
    }
  }
  .tip {
    text-align: center;
    color: red;
  }
  .center {
    margin-bottom:18px;
    text-align: center;
    &:nth-child(2) {
      margin-bottom: 20px;
    }
  }
  .red {
    color: #F95555;
  }
  .el-form--inline {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/users/people-management.vue